import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import Login from './pages/LoginPage';
import DynamicScreen from './pages/DynamicScreen';
import DynamicScreenTest from './pages/DynamicScreenTesting';
import Home from './pages/Home';
import View from './pages/View';
import Relationship_data from './pages/Relationship_data';
import JobApplication from './pages/job_application';
import A from './pages/JobApplication'
import JobExit from './pages/Job_Exit_form';
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    localStorage.getItem('loggedIn') === 'true'
      ? <Component {...props} />
      : <Redirect to='/login' />
  )} />
);
const App = () => {
  return (
    <Router>
      <div className="App">
        <Route exact path="/login" component={Login} />
        <Route exact path="/jobApplication" component={A} />
        <Route exact path="/JobExitForm" component={JobExit} />
        <PrivateRoute exact path="/" component={DynamicScreen} />
        <PrivateRoute exact path="/DScreen" component={DynamicScreen} />
        <PrivateRoute exact path="/Relation" component={Relationship_data} />
        <PrivateRoute exact path="/Home" component={Home} />
        {/* Other routes */}
      </div>
    </Router>
  );
};
export default App;
